export default __webpack_public_path__ + "static/media/fundow03.62285df7.png";